import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowRightOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m18.554 12.9-6.827 6.827L13 21l9-9-9-9-1.273 1.273 6.827 6.827H2v1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowRightOutlinedSize24Glyph.displayName = 'ArrowRightOutlinedSize24Glyph';
